import React, {useState, useEffect} from 'react';
import {InputProps} from "components/forms/Input";
import {IonItem, IonLabel, IonSelect, IonSelectOption} from "@ionic/react";


interface SelectInputProps extends InputProps {
  options: any[],
  getOptionLabel?: (instance: any) => string;
  labelField?: string;
  valueField?: string;
  multiple?: boolean;
}

const SelectInput: React.FC<SelectInputProps> = (props) => {
  const {state, definition, labelPosition, disabled, multiple, labelField, valueField, getOptionLabel} = props;
  const currentValue = state.value;
  const currentOptions = props.options;
  const [value, setValue] = useState<any>();
  const [options, setOptions] = useState<any[]>([]);

  const interfaceOptions = props.interfaceOptions || {
    cssClass: "app-select-alert",
  };

  // set options
  useEffect(() => {
    if (!currentOptions.length) {
      // console.log(`Skip set ${currentValue}`);
    } else {
      // console.log('SET OPTIONS', currentOptions);
      setOptions(currentOptions);
    }
  }, [currentValue, currentOptions]);

  // set value
  useEffect(() => {
    if (options.length && currentValue !== value) {
      // console.log(`SET VALUE`, currentValue);
      setValue(currentValue);
    }
  }, [currentValue, options, value]);


  const onChange = (e: any) => {
    const _value = e.detail.value;
    if (_value !== undefined && value !== undefined && _value !== value) {
      // console.log(`onChange ${definition.name}: ${value} -> ${_value}`);
      props.onChange(definition.name, _value);
    }
  };

  return (
    <IonItem disabled={disabled} className="pr-1">
      <IonLabel
        position={labelPosition || 'floating'}
      >
        <span className={(state.touched && state.hasError) ? "text-red-600" : ""}>
          {definition.label} {definition.required && '*'}
        </span>
      </IonLabel>
      <IonSelect
        value={value}
        onIonChange={onChange}
        multiple={multiple || false}
        interfaceOptions={interfaceOptions}
      >
        {options.length && options.map((i, idx) => (
          <SelectInputOption
            key={`select-${definition.name}-option-${idx}`}
            value={i}
            labelField={labelField}
            valueField={valueField}
            getOptionLabel={getOptionLabel}
          />
        ))

        }
      </IonSelect>
    </IonItem>
  );
}

export default SelectInput;


interface SelectInputOptionProps {
  labelField?: string;
  valueField?: string;
  value: any;
  getOptionLabel?: (instance: any) => string;
}

const SelectInputOption: React.FC<SelectInputOptionProps> = (props) => {
  const {labelField, valueField, getOptionLabel} = props;
  const currentValue = props.value;
  const [value, setValue] = useState<any>();
  const [label, setLabel] = useState<string>();

  useEffect(() => {
    let _label: string;
    let _value: any;
    if (typeof currentValue === 'object') {
      if (!labelField || !valueField)
        throw Error('labelField or valueField undefined');

      _label = currentValue[labelField];
      _value = currentValue[valueField];
    } else {
      _label = currentValue;
      _value = currentValue;
    }
    setValue(_value);
    setLabel(_label);
  }, [currentValue, labelField, valueField]);

  return (
    <IonSelectOption
      value={value}
    >
      {getOptionLabel ? getOptionLabel(props.value) : label}
    </IonSelectOption>
  )
}